export default __webpack_public_path__ + "static/media/grafema_f1rst_07.b51ee025.mp4";